module.exports = __webpack_public_path__ + "static/media/classics-10217_01.7d03cd85.png";